import { TimeRegistrationBase } from '../../project/time-registration/_models/timeRegistrationBase';
import { Invoice } from './invoice';
import { Price } from './price';
import { Product } from './product';
import { User, UserType } from './user';

export enum ActionType {
    Create = 1,
    Read = 2,
    Update = 3,
    Delete = 4
}


export enum InvoiceActionType {
    DebugInfo = 5, ExtendedPriceinfo = 6
}

export enum PriceActionType {
    DebugInfo = 7, ExtendedPriceinfo = 8
}

export type AllActionTypes = ActionType | InvoiceActionType | PriceActionType;

export interface EntityPermission<T> {
    dataType: T;
    action: AllActionTypes[];
}

export interface IPermissions {
    products: EntityPermission<Product>;
    users: EntityPermission<User>;
    prices: EntityPermission<Price>;
    invoices: EntityPermission<Invoice>;
    timeRegistration: EntityPermission<TimeRegistrationBase>;
    admin: EntityPermission<any>;
}

// Define a separate type for the function signature
export type PermissionCheckFunction<T> = (user: User, data: T) => boolean;

// Use the function signature type in PermissionCheck
export type PermissionCheck<Key extends keyof IPermissions> =
    | boolean
    | PermissionCheckFunction<IPermissions[Key]['dataType']>;

// Define the RolesWithPermissions type
export type RolesWithPermissions = {
    [R in UserType]: Partial<{
        [Key in keyof IPermissions]: Partial<{
            [Action in AllActionTypes]: PermissionCheck<Key>
        }>
    }>
};